import { capitalize } from '@sketch/utils'

export interface CopyProps {
  opacity: string
  blendMode: string
}

const copy = ({ opacity, blendMode }: CopyProps) => {
  const blendModeCopyValue =
    blendMode.toLowerCase() !== 'normal' ? ` (${capitalize(blendMode)})` : ''

  return `Opacity: ${opacity}${blendModeCopyValue}`
}

export default copy
